import React, { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { trackExceptionFromUnknown } from '../telemetry/appInsights';

/**
 * React Router `errorElement` — catches errors from loaders/actions/rendering in the route subtree.
 */
export function RouteErrorFallback(): React.ReactElement {
  const error = useRouteError();

  useEffect(() => {
    trackExceptionFromUnknown(error, { source: 'react-router-errorElement' });
  }, [error]);

  let message = 'An unexpected error occurred.';
  if (isRouteErrorResponse(error)) {
    message = error.statusText || `Error ${error.status}`;
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="bo-root">
      <main className="bo-main">
        <div className="bo-card" role="alert">
          <h1 style={{ marginTop: 0, fontSize: '1.25rem' }}>Navigation error</h1>
          <p style={{ color: '#64748b' }}>{message}</p>
          <a className="bo-btn bo-btn-primary" href="/" style={{ textDecoration: 'none', display: 'inline-block' }}>
            Go home
          </a>
        </div>
      </main>
    </div>
  );
}
